import { CONV_STORAGE, Video, animatedLayers, deviceManager, kinoParticipants, privacyMode, room, screenShare, vb } from "../../../libs/roomnew"
import { attachTrackToSmallPlayer, createSmallPlayer, enableScreenshareView, removeSmallPlayer } from "../../screen-share/ScreenshareUI"
import { getPerformanceState } from "../performance-optimizer/functions"
import { updateVideoQuality } from "../video-quality/actions"
import { getCurrentMaxResolution } from "../video-quality/functions"
import { MEDIA_TYPE, STREAMING_STATUS, TRACK_EVENTS } from "./constants"
import { findTrackByKinoTrack, getLocalTrack, getRemoteParticipantDesktopTrack, getRemoteParticipantMainVideoTrack, getRemoteParticipantTrack, removeLocalVideoTrack, setLocalVideoMuted, setSenderMaxFramerate } from "./functions"

export const addTrackEventHandlers=()=>{

    window.addEventListener(TRACK_EVENTS.REMOTE_TRACK_ADDED,({detail:track})=>{
        console.log(`%c[EVENT]%c - REMOTE_TRACK_ADDED`,'color:green','color:unset',track)
        onRemoteTrack(track)
    })

    window.addEventListener(TRACK_EVENTS.REMOTE_TRACK_MUTE_CHANGED,({detail:track})=>{
        console.log(`%c[EVENT]%c - REMOTE_TRACK_MUTE_CHANGED`,'color:orange','color:unset',track)
        onRemoteTrackMuteChanged(track)
    })

    window.addEventListener(TRACK_EVENTS.SCREEN_SHARE_TRACK_ADDED,({detail:track})=>{
        console.log(`%c[EVENT]%c - SCREEN_SHARE_TRACK_ADDED`,'color:green','color:unset',track)
        onRemoteScreenshareTrackAdded(track);
    })
    window.addEventListener(TRACK_EVENTS.SCREEN_SHARE_TRACK_MUTE_CHANGED,({detail:track})=>{
        console.log(`%c[EVENT]%c - SCREEN_SHARE_TRACK_MUTE_CHANGED`,'color:orange','color:unset',track)
        onScreenshareTrackMuteChanged(track);
    })
    window.addEventListener(TRACK_EVENTS.SCREEN_SHARE_TRACK_REMOVED,({detail:track})=>{
        console.log(`%c[EVENT]%c - SCREEN_SHARE_TRACK_REMOVED`,'color:orange','color:unset',track)
        onScreenshareTrackRemoved(track);
    })
    window.addEventListener(TRACK_EVENTS.LOCAL_TRACK_ADDED,({detail:track})=>{
        console.log(`%c[EVENT]%c - LOCAL_TRACK_ADDED`,'color:green','color:unset',track)
        onLocalTrack(track)
    })

    window.addEventListener(TRACK_EVENTS.TRACK_STATUS_CHANGED,({detail:{track,status}})=>{
        console.log(`%c[EVENT]%c - TRACK_STATUS_CHANGED`,'color:green','color:unset',track,'status',status)
        onRemoteTrackStreamingStatusChanged(track,status)
    })

}


export const onLocalTrack=(track)=>{
    console.log(`[EVENT HANDLER] - LOCAL_TRACK_ADDED - ${track.type}`,track)

    if(track.type == MEDIA_TYPE.SCREENSHARE){
        // const videoTrack=getLocalTrack(MEDIA_TYPE.VIDEO);
        // removeLocalVideoTrack();
        // setLocalVideoMuted(true);
        console.log("Screenshare track added")
        track.kinoTrack.addEventListener(
            KinoJS.events.track.LOCAL_TRACK_STOPPED,
            () => {
                if(!screenShare.pendingStop && screenShare.isSharing()){
                    console.log("desktop sharing stopped was active:",screenShare.isSharing());
                    if(screenShare.isSharing()){
                        screenShare.stop();
                    }
                    setTimeout(() => {
                        Video && Video.localVideo.noLocalVideo();
                    }, 100);
                }else{
                    console.log("Skiping screenshare stop from LOCAL_TRACK_STOPPED")
                }
            }
        );

        screenShare.onScreenShareStart();
        Video && Video.localVideo.noLocalVideo();

        // track.kinoTrack.attach(document.getElementById(`localVideo1`));
        room.setLocalParticipantProperty("video_muted", false);
        enableScreenshareView(kinoParticipants.me());
        // if(!deviceManager.mutedWhileSharingScreen){
        //     console.log("Enabling camera , was not muted when started screenshare")
        //     // screenShare.getCameraTrack().then(async cameraTrack=>{
        //     //     if (vb.effectPlaying) {
        //     //         console.log("run effect");
        //     //         vb.cameraTrack = cameraTrack;
        //     //         cameraTrack = await vb.runEffect(cameraTrack);
        //     //     } else if (privacyMode.enabled) {
        //     //         console.log("privacy_mode", privacyMode);
        //     //         cameraTrack = await privacyMode.startPrivacyMode(cameraTrack);
        //     //     }
        //     //     screenShare.onCameraEnabled(cameraTrack);
        //     // })
        // }else{
        //     console.log("Not enabling camera , was muted when started screenshare")
        // }

    }else if(track.type == MEDIA_TYPE.AUDIO){
        track.kinoTrack.addEventListener(
            KinoJS.events.track.TRACK_AUDIO_OUTPUT_CHANGED,
            (deviceId) =>
                console.log(`[TRACK_AUDIO_OUTPUT_CHANGED] device was changed to ${deviceId}`)
        );
        deviceManager.saveMic(track.kinoTrack.getDeviceId(),track.kinoTrack.track.label)
    }else if(track.type == MEDIA_TYPE.VIDEO){
        const desktopTrack=getLocalTrack(MEDIA_TYPE.SCREENSHARE)
        if(screenShare.isSharing() && !desktopTrack?.muted){
            enableScreenshareView(kinoParticipants.me());
            return
        }
        Video.attachLocalVideo(1);
        track.kinoTrack.attach(document.getElementById(`localVideo1`));
        try {

            document.getElementById(`localVideo1`).srcObject=track.kinoTrack.stream;
            //update video stream in spaces panel
            const {maxFrameRate} = getPerformanceState();
            setSenderMaxFramerate(maxFrameRate)
            try {
                if(room){
                    CONV_STORAGE.updateVideoStream(room.myUserId());
                    room.setSenderVideoConstraint(getCurrentMaxResolution());
                }
            } catch (error) { console.error("[Kino Error] [events]", error); }
        } catch (error) {
            console.error(error)
        }
    }

}

export const onRemoteTrack=(track)=>{
    console.log(`[EVENT HANDLER] - REMOTE_TRACK_ADDED`,track)
    if(track.type == MEDIA_TYPE.VIDEO){

        // track.kinoTrack.track.onmute = event => onVideoStreamSuspended(track);

        Video.attachVideoToPlayer(track.pid, track.kinoTrack);

        if (room.getParticipantById(track.pid)?.getProperty("video_muted") || track.muted) {
            Video.cameraMuted(track.pid, true);
            CONV_STORAGE.updateVideoStream(track.pid);
            track.muted = true;
        } else {
            track.kinoTrack.track.onunmute = event => onVideoStreamResumed(track);
            Video.cameraMuted(track.pid, track.muted);
        }

    }else if(track.type == MEDIA_TYPE.AUDIO){
        Video.attachAudio(track.pid, track.kinoTrack);
        Video.speaker.attachEvent(track.pid, track.kinoTrack.getOriginalStream());
        // A freshly received remote audio track defaults to muted until presence signaling
        // arrives, which can leave the mic icon stuck "muted" for a participant whose mic is
        // actually live. Reconcile against the authoritative audio_muted property the sender
        // broadcasts (mirrors the video_muted handling above) so the icon reflects reality.
        reconcileRemoteMicState(track);
        // Presence and media negotiation are async: the audio_muted property may not have
        // arrived yet when this track event fires. Re-check once it has settled so the icon
        // does not stay stuck muted for a participant whose mic is actually live.
        setTimeout(() => reconcileRemoteMicState(track), 1500);
        track.kinoTrack.attach($(`#${track.pid}-audio-player`)[0]);
    }

}

// Resolve a remote participant's true mic-muted state from the authoritative audio_muted
// property (sent over presence as the string "true"/"false"), falling back to the track's
// own (initially unreliable) muted flag only when the peer never published the property.
const reconcileRemoteMicState=(track)=>{
    const audioMutedProp = room.getParticipantById(track.pid)?.getProperty("audio_muted");
    let isMicMuted;
    if (audioMutedProp === "true" || audioMutedProp === true) {
        isMicMuted = true;
    } else if (audioMutedProp === "false" || audioMutedProp === false) {
        isMicMuted = false;
    } else {
        isMicMuted = track.kinoTrack?.isMuted?.() ?? track.muted;
    }
    Video.micMuted(track.pid, isMicMuted);
}


export const onRemoteScreenshareTrackAdded=(track)=>{
    // track.kinoTrack.track.onmute = event => onVideoStreamSuspended(track);
    const user = Video.videos[track.pid];
    if(!track.muted && user && user?.isSharingScreen){
        console.log("Adding screenshare track events")
        track.kinoTrack.track.onunmute = event => onVideoStreamResumed(track);
        const p = kinoParticipants.get(track.pid);
        p.setScreenShareMode(true);
        Video.cameraMuted(track.pid,false)
        // Video.attachVideoToPlayer(track.pid, track.kinoTrack);
        // if(Video.videos[track.pid]){
        //     Video.videos[track.pid].videoTypeChanged(MEDIA_TYPE.DESKTOP)
        // }
    }
}


export const onScreenshareTrackMuteChanged=(track)=>{
    if(track.type == MEDIA_TYPE.SCREENSHARE){
        console.log("CHecking if screenshare track mute state is saved",getRemoteParticipantDesktopTrack(track.pid))
        console.log(`Screenshare track is muted`,track.muted)
        const p = kinoParticipants.get(track.pid);
        if(Video.videos[track.pid]?.showLoadingSpinner){
            Video.videos[track.pid].showLoadingSpinner();
        }
        p.setScreenShareMode(!track.muted);
        if(track.muted){
            const videoTrack=getRemoteParticipantTrack(track.pid,MEDIA_TYPE.VIDEO);
            if(videoTrack){
                if(videoTrack.muted){
                    Video.cameraMuted(videoTrack.pid,true)
                }
                Video.attachVideoToPlayer(videoTrack.pid, videoTrack.kinoTrack);
            }else{
                Video.cameraMuted(track.pid,true)
            }
            track.kinoTrack.track.onunmute = null;
            if(Video.videos[track.pid]){
                Video.videos[track.pid].videoTypeChanged(MEDIA_TYPE.VIDEO)
            }
        }else{
            Video.cameraMuted(track.pid,false)
            if(Video.videos[track.pid]){
                Video.videos[track.pid].videoTypeChanged(MEDIA_TYPE.DESKTOP)
            }
            track.kinoTrack.track.onunmute = event => onVideoStreamResumed(track);
        }
        updateVideoQuality(false,true)
    }

}

export const onScreenshareTrackRemoved=(track)=>{

    if(track.type == MEDIA_TYPE.SCREENSHARE){
        if(Video.videos[track.pid] && Video.videos[track.pid].hasDesktopTrack){
            try {
                const p = kinoParticipants.get(track.pid);
                p.setScreenShareMode(false);
                track.kinoTrack.track.onunmute = null;
            } catch (error) { console.error("[Kino Error] [events]", error); }
        }
    }
}

export const onRemoteTrackStreamingStatusChanged=(track,status)=>{

    if(status === STREAMING_STATUS.INACTIVE || status===STREAMING_STATUS.INTERRUPTED || status == STREAMING_STATUS.RESTORING){
        onVideoStreamSuspended(track)
    }else if(status === STREAMING_STATUS.ACTIVE && !track.muted){
        onVideoStreamResumed(track);
    }
}
export const onVideoStreamSuspended=(track)=>{
    try {
        console.log(`%c[SUSPENDED]%c Video stream type=${track.type}, srcName=${track.kinoTrack.getSourceName()}`,'color:orange','color:unset')
        const mainVideoTrack=getRemoteParticipantMainVideoTrack(track.pid);
        const videoTrack = findTrackByKinoTrack(track.pid,track.kinoTrack);
        console.log("MAIN video Track",videoTrack)
        if(mainVideoTrack && mainVideoTrack.kinoTrack.getSourceName() == track.kinoTrack.getSourceName()){
            if(Video.videos[track.pid] && videoTrack && videoTrack.kinoTrack.getSourceName() == track.kinoTrack.getSourceName()){
                Video.videos[track.pid].isVideoPlaying=false;
                Video.videos[track.pid].videoWillMute();
            }
        }else{
            console.log("Not main video track")

        }
    } catch (error) {
        console.error("ERROR onVideoStreamSuspended",error)
    }
}

export const onVideoStreamResumed=(track)=>{
    try {
        console.log(`%c[RESUMED]%c Video stream type=${track.type}, srcName=${track.kinoTrack.getSourceName()}`,'color:green','color:unset')
        const mainVideoTrack=getRemoteParticipantMainVideoTrack(track.pid);
        const videoTrack = findTrackByKinoTrack(track.pid,track.kinoTrack);
        if(mainVideoTrack && mainVideoTrack.kinoTrack.getSourceName() == track.kinoTrack.getSourceName()){
            if(Video.videos[track.pid] && videoTrack && videoTrack.kinoTrack.getSourceName() == track.kinoTrack.getSourceName()){
                if(!Video.videos[track.pid]?.isVideoPlaying){
                    console.trace("Video track has been unmuted remove layer",track);
                    CONV_STORAGE.updateVideoStream(track.pid);
                }
                Video.videos[track.pid].onVideoUnmuted();
                animatedLayers.removeLocalConnectionLostLayer();
                Video.videos[track.pid].isVideoPlaying=true;
            }
        }else{
            console.log("Not main video track")
        }
        // if(track.screenshare){
        //     removeScreenshareLayer(track.pid)
        // }
    } catch (error) {
        console.error("ERROR onVideoStreamResumed",error)
    }
}

export const removeScreenshareLayer=(pid)=>{
    try {
        console.log("Removing screenshare layer for",pid)
        console.log("Participant",Video.videos[pid])
        clearTimeout(Video.videos[pid].waitingForScreenShareTimer);
        clearTimeout(Video.videos[pid].waitingForScreenVideoTimer);
        Video.videos[pid].waitingForScreen=false;
        Video.removeInformativeLayer(pid);
    } catch (error) { console.error("[Kino Error] [events]", error); }

}
export const onRemoteTrackMuteChanged=(track)=>{
    try {
        if(track.type == MEDIA_TYPE.SCREENSHARE){
            onScreenshareTrackMuteChanged(track)
            return
        }
        const desktopTrack=getRemoteParticipantDesktopTrack(track.pid);
        if(!desktopTrack){
            Video.cameraMuted(track.pid,track.muted)
        }else if(desktopTrack && track.type == MEDIA_TYPE.VIDEO){
            const p = kinoParticipants.get(track.pid);
            if(track.muted){
                removeSmallPlayer(p);
            }else if(track && !track.kinoTrack?.isMuted()){
                createSmallPlayer(p);
                attachTrackToSmallPlayer(p,track);
            }
        }
        if(track.type != MEDIA_TYPE.AUDIO){
            if(track.muted){
                track.kinoTrack.track.onunmute = event => null;
            }else{
                track.kinoTrack.track.onunmute = event => onVideoStreamResumed(track);
            }
        }
    } catch (error) {
        console.error("Remote track muted error",error)
    }
}
